import { Stack } from "@mui/material";
import type { FC, ReactNode } from "react";
import { ChatDayDivider } from "web_myplann/Chat/Components/Messages/ChatDayDivider";
import { ChatRecipientMessage } from "web_myplann/Chat/Components/Messages/ChatRecipientMessage";
import { ChatSenderMessage } from "web_myplann/Chat/Components/Messages/ChatSenderMessage";
import { formatChatDayLabel } from "web_myplann/Chat/Helpers/chatFormatting";
import { getChatMessageKey } from "web_myplann/Chat/Helpers/Messages/getChatMessageKey";
import type {
	ChatMessageGroupView,
	ChatMessageView,
} from "web_myplann/Chat/Types/chatMessage";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	group: ChatMessageGroupView;
	advisorName: string;
	advisorPhoto?: string;
	onRetry: (message: ChatMessageView) => void;
};

export const ChatMessageGroup: FC<Props> = ({
	group,
	advisorName,
	advisorPhoto,
	onRetry,
}) => {
	const { t } = useResource();
	let messageElements: ReactNode;

	if (group.direction === "sender") {
		messageElements = group.messages.map((message) => (
			<ChatSenderMessage
				key={getChatMessageKey(message)}
				message={message}
				onRetry={onRetry}
			/>
		));
	} else {
		messageElements = group.messages.map((message) => (
			<ChatRecipientMessage
				key={getChatMessageKey(message)}
				message={message}
				advisorName={advisorName}
				advisorPhoto={advisorPhoto}
			/>
		));
	}

	return (
		<>
			{group.date && (
				<ChatDayDivider
					label={formatChatDayLabel(
						group.date,
						t(Resources.Chat.today),
						t(Resources.Chat.yesterday),
					)}
				/>
			)}
			<Stack className="chat_group" data-message-direction={group.direction}>
				{messageElements}
			</Stack>
		</>
	);
};
